import { useEffect, useRef } from 'react'

export interface ChatInputPulseOptions {
  /** Also focus the input — the hotkey path asks for this, menu paths don't. */
  focus?: boolean
}

type ChatInputPulseListener = (options?: ChatInputPulseOptions) => void

const listeners = new Set<ChatInputPulseListener>()

/**
 * "New chat" pressed while the new chat is already open: nothing navigates, so
 * the input acknowledges the press with a pulse. A module-local emitter, not
 * GlobalEvents — the emitters (toolbar menu, hotkey handler) and the sole
 * listener (SidepanelChatInput) all live in this renderer, and a same-process
 * command shouldn't cross IPC (ipc-performance.mdc).
 */
export function pulseChatInput(options?: ChatInputPulseOptions) {
  for (const listener of listeners) {
    listener(options)
  }
}

export function useChatInputPulse(handler: ChatInputPulseListener) {
  const handlerRef = useRef(handler)
  handlerRef.current = handler

  useEffect(() => {
    const listener: ChatInputPulseListener = (options) => handlerRef.current(options)
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  }, [])
}
